"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CommonBaseError extends Error {
    //public readonly innerError?: Error;
    constructor(message, innerError) {
        // 'Error' breaks prototype chain here
        super(message);
        //super(`${message}${innerError ? ", Reason=" + innerError.message : ""}`);
        this.name = this.constructor.name;
        // restore prototype chain
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            //this.__proto__ = actualProto;
            //Because local dev environment don't have __proto__, using this way to assign it.
            const thisAsAny = this;
            if (thisAsAny.__proto__)
                thisAsAny.__proto__ = actualProto;
        }
        if (innerError) {
            //this.innerError = innerError;//record innererror
            this.stack = innerError.stack;
        }
    }
}
exports.CommonBaseError = CommonBaseError;
//# sourceMappingURL=CommonBaseError.js.map